module.exports = __webpack_public_path__ + "static/assets/c2f52de75b31a05cb82e70bba101cdde.svg";